import Head from 'next/head'

export default ({ banner, isMobile }) => {
  return !!banner ? (
    <Head>
      {!!banner && (
        <link
          rel="preload"
          href={isMobile ? banner.imageDouble?.url : banner.image?.url}
          as="image"
        />
      )}
    </Head>
  ) : null
}
